import React, { Component, useState } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
// import GeneralForm from "../Forms/GeneralForm";

import useValidation from "hooks/useDValidation";
import {
  userFormFields,
  AllUserFormFields,
} from "../../slices/models/generalForm.model";
import GeneralForm from "../Forms/GeneralForm";

const TabContainer = ({ children, dir }) => {
  return (
    <div dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </div>
  );
};

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const FullWidthTabs = (props) => {
  const [value, setValue] = useState(0);
  const { errors, checkFiled, checkValidation } = useValidation({
    data: AllUserFormFields,
    key: "adminFullForm",
  });

  const [validations, setValidations] = useState({
    general: true,
  });
  const handleChange = (event, value) => {
    setValue(value);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const generalValidation = useValidation({
    data: userFormFields,
    key: "generalForm",
  });

  const validators = {
    general: async function (fields) {
      const valid = await generalValidation.checkValidation(fields);
      return setValidations((prev) => ({ ...prev, ops: valid }));
    },
  };

  const { theme } = props;

  return (
    <div className="w-100">
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          scrollButtons="on"
        >
          <Tab className="tab" label="General" />
          {/* <Tab className="tab" label="Rating" />
          <Tab className="tab" label="Other" /> */}
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabContainer dir={theme.direction}>
          <GeneralForm
            validation={{ errors, checkFiled, checkValidation }}
            validators={validators}
          />
        </TabContainer>
      </SwipeableViews>
    </div>
  );
};

FullWidthTabs.propTypes = {
  theme: PropTypes.object.isRequired,
};

export default withStyles(null, { withTheme: true })(FullWidthTabs);
